import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Container,
  Card,
  ListGroupItem,
  ListGroup,
  Spinner,
  Collapse,
} from "reactstrap";
import _ from "lodash";
import API from "services/WebAPI";
import EditPath from "./edit";
import { useDispatch } from "react-redux";
import { alertActions } from "redux/_actions";
import AlertMessage from "components/Alert";

const ListItem = ({ data, update, index }) => {
  const [open, setOpen] = useState(false);
  return (
    <ListGroupItem>
      <Collapse isOpen={open}>
        <EditPath
          index={index}
          data={data}
          open={open}
          onClose={() => setOpen(false)}
          update={update}
        />
      </Collapse>
      {!open && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {data}
          <Button
            onClick={() => setOpen(!open)}
            size="sm"
            outline
            color="secondary"
          >
            <i class="fas fa-pen" />
          </Button>
        </div>
      )}
    </ListGroupItem>
  );
};

const ProcessRestiction = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [rowData, setRowData] = useState([]);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    loadExceptions();
  }, []);

  const loadExceptions = async () => {
    setloading(true);
    try {
      const res = await API.get("/Settings/GetProhibittedAllowedProcesses");
      if (res.data.status) {
        setRowData(res.data?.result?.patterns || []);
      }
    } catch (error) {
      console.log("error", error);
    }
    setloading(false);
  };

  const updateException = async (index, type, data) => {
    try {
      const _data = [...rowData];
      switch (type) {
        case "add": {
          if (index === "new") _data.push(data);
          else _data.splice(index, 1, data);
          break;
        }
        case "delete": {
          _data.splice(index, 1);
        }
      }
      const req = { patterns: _data };
      const res = await API.post(
        "/Settings/SetProhibittedAllowedProcesses",
        req
      );
      if (res.data?.status) {
        dispatch(alertActions.success("Updated the list successfully!"));
        loadExceptions();
      }
    } catch (error) {
      console.log("error", error);
    }
    setTimeout(() => {
      dispatch(alertActions.clear());
    }, 2500);
    return true;
  };

  return (
    <>
      <Container className="container-main" fluid>
        <div className="common-headers">
          <Button
            className="common-btn-back mr-2"
            outline
            onClick={() => history.go("-1")}
          >
            <i className="fas fa-chevron-left" />
          </Button>
          Process Whitelist Exception
        </div>
        <AlertMessage />
        <Card style={{ padding: 10 }}>
          <EditPath update={updateException} />
        </Card>
        <Card style={{ marginTop: 10, padding: 10 }}>
          Restricted paths
          <ListGroup style={{ marginTop: 3 }}>
            {(loading && (
              <ListGroupItem>
                <Spinner color="primary" size="sm" />
              </ListGroupItem>
            )) ||
              rowData.map((h, index) => (
                <ListItem index={index} data={h} update={updateException} />
              ))}
          </ListGroup>
        </Card>
      </Container>
    </>
  );
};

export default ProcessRestiction;
